package com.milta.core.localization.translations.it

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Importa — Foto",
    titlePdf = "Importa — PDF",
    titleSpreadsheet = "Importa — Excel / CSV",
    fileSentSuffix = "appena inviato",
    fileWaitingConnectionLabel = "in attesa di connessione",
    analysingTitle = "Lettura del documento…",
    analysingSubtitle = "L'estrazione delle consegne può richiedere alcuni secondi.",
    analysingSubtitlePdf = "Claude Haiku estrae le consegne — può richiedere alcuni secondi su un PDF scansionato.",
    stepFileSent = "File inviato",
    stepExtracting = "Estrazione dei campi",
    stepReview = "Verifica prima dell'aggiunta",
    successTitle = "Consegna rilevata",
    successSubtitle = "Verifica le informazioni prima di aggiungerle al percorso.",
    addToRouteButton = "Aggiungi al percorso",
    scanAnotherButton = "Scansiona un altro documento",
    partialTitle = "Quasi completo",
    partialSubtitle = "Un campo non è stato letto correttamente sul documento.",
    missingFieldPlaceholder = "Da completare…",
    partialBannerText = "Alcune informazioni non sono state lette. Puoi confermare così com'è e completarle più tardi, oppure inviare un documento più nitido.",
    retryFileButton = "Invia un altro file",
    validateAndContinueButton = "Confermare e continua",
    attemptLabel = "Tentativo",
    errorTitleUnreadable = "Documento illeggibile",
    errorTitleMissingFields = "Informazioni non trovate",
    errorTitleNetworkError = "Problema durante l'analisi",
    errorTitleGeneric = "Analisi non riuscita",
    errorSubtitle = "Non siamo riusciti a rilevare una consegna in questo file.",
    errorBannerSuffixUnreadable = "immagine troppo scura o testo tagliato. Scatta una foto ben inquadrata e ben illuminata, oppure invia un file più nitido.",
    errorBannerSuffixMissingFields = "non è stata trovata nessuna informazione utilizzabile. Controlla il contenuto del file o invia un altro file.",
    errorBannerSuffixNetworkError = "il servizio di analisi ha riscontrato un problema di rete. Riprova entro pochi istanti.",
    errorBannerSuffixGeneric = "si è verificato un errore imprevisto durante l'analisi. Riprova o invia un altro file.",
    retryWithNewFileButton = "Riprova con un altro file",
    manualEntryButton = "Inserisci manualmente",
    attemptsRemainingNote = "Ti resta 1 tentativo per questo documento.",
    maxAttemptsTitle = "Ancora illeggibile",
    maxAttemptsSubtitle = "Questo documento non è stato leggibile dopo 2 tentativi.",
    maxAttemptsBanner = "Limite di tentativi raggiunto per questo documento. Completa la consegna manualmente, oppure riavvia l'importazione con un nuovo documento.",
    retryUnavailableButton = "Riprova — non disponibile",
    newDocumentButton = "Importa un nuovo documento",
    serviceUnavailableTitle = "Servizio temporaneamente non disponibile",
    serviceUnavailableSubtitle = "L'analisi automatica non risponde al momento.",
    serviceUnavailableBanner = "Riprova entro pochi istanti, oppure completa la consegna manualmente nel frattempo.",
    offlineTitle = "Sei offline",
    offlineSubtitle = "Il tuo file è pronto ma non è ancora stato inviato.",
    offlineBanner = "Riconnettiti a Internet e riavvia l'analisi. Nulla è stato inviato al server — nessun tentativo è stato conteggiato.",
    retryOfflineButton = "Riprova — nessuna connessione",
    unsupportedFormatBanner = "Formato di file non supportato. Scegli una foto, un PDF o un file Excel/CSV.",
    validationTitle = "Verifica le consegne",
    fileRejectedTitle = "File non inviato",
    fileRejectedSubtitle = "Scegli un altro file per continuare.",
    bannerFileRequired = "nessun file selezionato. Scegli un file PDF per continuare.",
    bannerInvalidPdfFormat = "formato non supportato. Qui sono accettati solo file PDF.",
    bannerFileTooLarge = "file troppo grande. Scegli un file PDF più leggero.",
    chooseAnotherFileButton = "Scegli un altro file",
)
